export type Internacion = {
  fechaInicio: Date;
  fechaFin: Date;
  descripcion: string;
  costo: string;
};

export const getEmptyInternaciones: Internacion[] = [];
